import { MobizSettingsValue } from '../../common-react/settings';

import { OnboardingStep } from '../interfaces/onboarding-step.interface';

export class OnboardingState extends MobizSettingsValue {
  currentStep: OnboardingStep = OnboardingStep.GDPR;
}
